{
  "identities.messages.1010001": "Kirjaudu sisään",
  "identities.messages.1010002": "Kirjaudu sisään {provider}-tunnuksella",
  "identities.messages.1010003": "Vahvista tämä toiminto varmistamalla, että se olet sinä.",
  "identities.messages.1010004": "Suorita toinen todennushaaste.",
  "identities.messages.1010005": "Vahvista",
  "identities.messages.1010006": "Todennuskoodi",
  "identities.messages.1010007": "Varmuuskoodi",
  "identities.messages.1010008": "Jatka laiteavaimella",
  "identities.messages.1010009": "Jatka",
  "identities.messages.1010010": "Jatka",
  "identities.messages.1010011": "Kirjaudu sisään laiteavaimella",
  "identities.messages.1010012": "Valmistele WebAuthn-laitteesi (esim. turva-avain, biometrinen skanneri, ...) ja paina jatka.",
  "identities.messages.1010013": "Jatka",
  "identities.messages.1010014": "Koodi lähetettiin antamaasi osoitteeseen. Jos et saanut sitä, tarkista osoitteen oikeinkirjoitus ja yritä uudelleen.",
  "identities.messages.1010015": "Lähetä sisäänkirjautumiskoodi",
  "identities.messages.1010016": "Yritit kirjautua sisään tunnuksella \"{duplicateIdentifier}\", mutta kyseistä sähköpostiosoitetta käyttää jo toinen tili. Kirjaudu sisään tilillesi jollakin alla olevista vaihtoehdoista lisätäksesi \"{duplicateIdentifier}\"-tilisi palvelussa \"{provider}\" toiseksi sisäänkirjautumistapaksi.",
  "identities.messages.1010017": "Kirjaudu sisään ja linkitä",
  "identities.messages.1010018": "Vahvista {provider}-tunnuksella",
  "identities.messages.1010019": "Pyydä koodia jatkaaksesi",
  "identities.messages.1010021": "Kirjaudu sisään pääsyavaimella",
  "identities.messages.1010022": "Kirjaudu sisään salasanalla",
  "identities.messages.1010023": "Lähetä koodi osoitteeseen {address}",
  "identities.messages.1040001": "Rekisteröidy",
  "identities.messages.1040002": "Rekisteröidy {provider}-tunnuksella",
  "identities.messages.1040003": "Jatka",
  "identities.messages.1040004": "Rekisteröidy turva-avaimella",
  "identities.messages.1040005": "Koodi on lähetetty antamaasi osoitteeseen/osoitteisiin. Jos et ole saanut viestiä, tarkista osoitteen oikeinkirjoitus ja yritä rekisteröintiä uudelleen.",
  "identities.messages.1040006": "Lähetä rekisteröitymiskoodi",
  "identities.messages.1040007": "Rekisteröidy pääsyavaimella",
  "identities.messages.1040008": "Takaisin",
  "identities.messages.1040009": "Valitse tunniste, jolla todentaa itsesi.",
  "identities.messages.1050001": "Muutoksesi on tallennettu!",
  "identities.messages.1050002": "Linkitä {provider}",
  "identities.messages.1050003": "Poista {provider}-linkitys",
  "identities.messages.1050004": "Poista TOTP-todentajasovelluksen linkitys",
  "identities.messages.1050005": "Todentajasovelluksen QR-koodi",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Näytä varmuuskoodit",
  "identities.messages.1050008": "Ota käyttöön",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Nämä ovat varmuuskoodeistasi. Säilytä niitä turvallisessa paikassa!",
  "identities.messages.1050011": "Vahvista varmuuskoodit",
  "identities.messages.1050012": "Lisää turva-avain",
  "identities.messages.1050013": "Turva-avaimen nimi",
  "identities.messages.1050014": "Salaista käytettiin {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Poista tämä menetelmä käytöstä",
  "identities.messages.1050017": "Todentajan salaisuus",
  "identities.messages.1050018": "Poista turva-avain \"{display_name}\"",
  "identities.messages.1050019": "Lisää pääsyavain",
  "identities.messages.1050020": "Poista pääsyavain \"{display_name}\"",
  "identities.messages.1060001": "Tilisi palautus onnistui. Vaihda salasanasi tai aseta vaihtoehtoinen kirjautumistapa (esim. sosiaalinen kirjautuminen) seuraavan {privileged_session_expires_at_unix_until_minutes} minuutin aikana.",
  "identities.messages.1060002": "Palautuslinkki on lähetetty antamaasi sähköpostiosoitteeseen. Jos et ole saanut sähköpostia, tarkista osoitteen oikeinkirjoitus ja varmista, että käytät rekisteröintiaikaista osoitettasi.",
  "identities.messages.1060003": "Palautuskoodi on lähetetty antamaasi sähköpostiosoitteeseen. Jos et ole saanut sähköpostia, tarkista osoitteen oikeinkirjoitus ja varmista, että käytät rekisteröintiaikaista osoitettasi.",
  "identities.messages.1060004": "Palautuskoodi on lähetetty osoitteeseen \"{masked_address}\". Jos et ole saanut sitä, tarkista osoitteen oikeinkirjoitus ja varmista, että käytät rekisteröintiaikaista osoitettasi.",
  "identities.messages.1060005": "Palauta pääsy tilillesi antamalla palautusosoitteesi kokonaisuudessaan.",
  "identities.messages.1060006": "Miten haluat palauttaa tilisi?",
  "identities.messages.1060007": "Takaisin",
  "identities.messages.1070001": "Salasana",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Tallenna",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Lähetä",
  "identities.messages.1070006": "Vahvista koodi",
  "identities.messages.1070007": "Sähköposti",
  "identities.messages.1070008": "Lähetä koodi uudelleen",
  "identities.messages.1070009": "Jatka",
  "identities.messages.1070010": "Palautuskoodi",
  "identities.messages.1070011": "Vahvistuskoodi",
  "identities.messages.1070012": "Rekisteröintikoodi",
  "identities.messages.1070013": "Kirjautumiskoodi",
  "identities.messages.1070014": "Kirjaudu sisään ja linkitä tunniste",
  "identities.messages.1070015": "Suorita captcha-haaste jatkaaksesi.",
  "identities.messages.1070016": "Palautusosoite",
  "identities.messages.1070017": "Puhelinnumero",
  "identities.messages.1080001": "Vahvistuslinkki on lähetetty antamaasi sähköpostiosoitteeseen. Jos et ole saanut sähköpostia, tarkista osoitteen oikeinkirjoitus ja varmista, että käytät rekisteröintiaikaista osoitettasi.",
  "identities.messages.1080002": "Vahvistit sähköpostiosoitteesi onnistuneesti.",
  "identities.messages.1080003": "Vahvistuskoodi on lähetetty antamaasi sähköpostiosoitteeseen. Jos et ole saanut sähköpostia, tarkista osoitteen oikeinkirjoitus ja varmista, että käytät rekisteröintiaikaista osoitettasi.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Anna {property} ja yritä uudelleen.",
  "identities.messages.4000003": "pituuden on oltava >= {min_length}, mutta sai {actual_length}",
  "identities.messages.4000004": "ei vastaa mallia \"{pattern}\"",
  "identities.messages.4000005": "Salasanaa ei voida käyttää, koska {reason}.",
  "identities.messages.4000006": "Annetut tunnistetiedot ovat virheelliset, tarkista kirjoitusvirheet salasanassasi tai käyttäjätunnuksessasi, sähköpostiosoitteessasi tai puhelinnumerossasi.",
  "identities.messages.4000007": "Tili samalla tunnisteella (sähköposti, puhelin, käyttäjätunnus, ...) on jo olemassa.",
  "identities.messages.4000008": "Annettu todennuskoodi on virheellinen, yritä uudelleen.",
  "identities.messages.4000009": "Kirjautumistunnisteita ei löytynyt. Unohditko asettaa ne? Tämä voi johtua myös palvelimen väärin konfiguraatiosta.",
  "identities.messages.4000010": "Tili ei ole vielä aktiivinen. Unohditko vahvistaa sähköpostiosoitteesi?",
  "identities.messages.4000011": "Sinulla ei ole TOTP-laitetta asetettuna.",
  "identities.messages.4000012": "Tätä varmuuskoodia on jo käytetty.",
  "identities.messages.4000013": "Sinulla ei ole WebAuthn-laitetta asetettuna.",
  "identities.messages.4000014": "Sinulla ei ole varmuuskoodeja asetettuna.",
  "identities.messages.4000015": "Tätä tiliä ei ole olemassa tai sillä ei ole turva-avainta asetettuna.",
  "identities.messages.4000016": "Varmuuskoodi ei ole kelvollinen.",
  "identities.messages.4000017": "pituuden on oltava <= {max_length}, mutta sai {actual_length}",
  "identities.messages.4000018": "täytyy olla >= {minimum} mutta löydettiin {actual}",
  "identities.messages.4000019": "täytyy olla > {minimum} mutta löydettiin {actual}",
  "identities.messages.4000020": "täytyy olla <= {maximum} mutta löydettiin {actual}",
  "identities.messages.4000021": "täytyy olla < {maximum} mutta löydettiin {actual}",
  "identities.messages.4000022": "{actual} ei ole jaollinen {base}:lla",
  "identities.messages.4000023": "maksimi {max_items} kohdetta sallittu, mutta löydettiin {actual_items} kohdetta",
  "identities.messages.4000024": "minimi {min_items} kohdetta sallittu, mutta löydettiin {actual_items} kohdetta",
  "identities.messages.4000025": "kohteet indekseissä {index_a} ja {index_b} ovat samat",
  "identities.messages.4000026": "odotettiin {allowed_types_list}, mutta saatiin {actual_type}",
  "identities.messages.4000027": "Tili samalla tunnisteella (sähköposti, puhelin, käyttäjätunnus, ...) on jo olemassa. Kirjaudu sisään olemassa olevalle tilillesi linkittääksesi sosiaalisen profiilisi.",
  "identities.messages.4000028": "Yritit kirjautua sisään tunnisteella {credential_identifier_hint}, joka on jo toisen tilin käytössä. Voit kirjautua sisään käyttämällä {available_credential_types_list}. Voit kirjautua sisään käyttämällä jotakin seuraavista sosiaalisen kirjautumisen tarjoajista: {available_oidc_providers_list}.",
  "identities.messages.4000029": "täytyy olla yhtä suuri kuin vakio {expected}",
  "identities.messages.4000030": "vakio epäonnistui",
  "identities.messages.4000031": "Salasanaa ei voida käyttää, koska se on liian samanlainen tunnisteen kanssa.",
  "identities.messages.4000032": "Salasanan täytyy olla vähintään {min_length} merkkiä pitkä, mutta sai {actual_length}.",
  "identities.messages.4000033": "Salasanan täytyy olla korkeintaan {max_length} merkkiä pitkä, mutta sai {actual_length}.",
  "identities.messages.4000034": "Salasana on löydetty tietomurroista eikä sitä saa enää käyttää.",
  "identities.messages.4000035": "Tätä tiliä ei ole olemassa tai sille ei ole asetettu koodilla kirjautumista.",
  "identities.messages.4000036": "Annetut ominaisuudet eivät vastaa aiemmin tähän prosessiin liitettyjä ominaisuuksia.",
  "identities.messages.4000037": "Tätä tiliä ei ole olemassa tai sille ei ole määritetty kirjautumistapaa.",
  "identities.messages.4000038": "Captcha-vahvistus epäonnistui, yritä uudelleen.",
  "identities.messages.4010001": "Yhteys katkesi. Yritä uudelleen.",
  "identities.messages.4010002": "Strategiaa kirjautumiseesi ei löytynyt. Täytitkö lomakkeen oikein?",
  "identities.messages.4010003": "Strategiaa rekisteröitymiseesi ei löytynyt. Täytitkö lomakkeen oikein?",
  "identities.messages.4010004": "Strategiaa asetustesi päivittämiseen ei löytynyt. Täytitkö lomakkeen oikein?",
  "identities.messages.4010005": "Strategiaa tilisi palauttamiseen ei löytynyt. Täytitkö lomakkeen oikein?",
  "identities.messages.4010006": "Strategiaa tilisi vahvistamiseen ei löytynyt. Täytitkö lomakkeen oikein?",
  "identities.messages.4010007": "Pyyntö on jo suoritettu onnistuneesti eikä sitä voi yrittää uudelleen.",
  "identities.messages.4010008": "Kirjautumiskoodi on virheellinen tai sitä on jo käytetty. Yritä uudelleen.",
  "identities.messages.4010009": "Linkitetyt tunnisteet eivät täsmää.",
  "identities.messages.4010010": "Antamasi osoite ei vastaa mitään tunnettua osoitetta nykyisellä tilillä.",
  "identities.messages.4040001": "Yhteys katkesi. Yritä uudelleen.",
  "identities.messages.4040002": "Pyyntö on jo suoritettu onnistuneesti eikä sitä voi yrittää uudelleen.",
  "identities.messages.4040003": "Rekisteröintikoodi on virheellinen tai sitä on jo käytetty. Yritä uudelleen.",
  "identities.messages.4050001": "Yhteys katkesi. Yritä uudelleen.",
  "identities.messages.4060001": "Pyyntö on jo suoritettu onnistuneesti eikä sitä voi yrittää uudelleen.",
  "identities.messages.4060002": "Palautusprosessi saavutti virhetilan ja se on yritettävä uudelleen.",
  "identities.messages.4060004": "Palautustunnus on virheellinen tai sitä on jo käytetty. Yritä prosessia uudelleen.",
  "identities.messages.4060005": "Yhteys katkesi. Yritä uudelleen.",
  "identities.messages.4060006": "Palautuskoodi on virheellinen tai sitä on jo käytetty. Yritä uudelleen.",
  "identities.messages.4070001": "Vahvistustunnus on virheellinen tai sitä on jo käytetty. Yritä prosessia uudelleen.",
  "identities.messages.4070002": "Pyyntö on jo suoritettu onnistuneesti eikä sitä voi yrittää uudelleen.",
  "identities.messages.4070003": "Vahvistusprosessi saavutti virhetilan ja se on yritettävä uudelleen.",
  "identities.messages.4070005": "Yhteys katkesi. Yritä uudelleen.",
  "identities.messages.4070006": "Vahvistuskoodi on virheellinen tai sitä on jo käytetty. Yritä uudelleen.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "Kirjaudu ulos",
  "login.registration-button": "Rekisteröidy",
  "login.registration-label": "Eikö sinulla ole tiliä?",
  "login.title": "Kirjaudu sisään",
  "login.subtitle": "Kirjaudu sisään käyttäen {parts}",
  "login.title-aal2": "Kaksivaiheinen todennus",
  "login.subtitle-aal2": "Valitse tapa suorittaa kaksivaiheinen todennuksesi",
  "login.code.subtitle": "Vahvistuskoodi lähetetään sähköpostitse",
  "login.webauthn.subtitle": "Valmistele WebAuthN-laitteesi",
  "login.totp.subtitle": "Anna todentajasovelluksesi luoma koodi",
  "login.lookup_secret.subtitle": "Anna yksi kahdeksannumeroisista varmuuskoodeistasi",
  "login.title-refresh": "Todennus uudelleen",
  "login.subtitle-refresh": "Vahvista identiteettisi käyttäen {parts}",
  "login.2fa.go-back": "Jokin ei toimi?",
  "login.2fa.go-back.link": "Takaisin",
  "login.2fa.method.go-back": "Valitse toinen menetelmä",
  "recovery.title": "Palauta tilisi",
  "recovery.subtitle": "Anna tiliisi liittyvä tunniste saadaksesi kertakäyttöisen pääsykoodin",
  "registration.login-button": "Kirjaudu sisään",
  "registration.login-label": "Onko sinulla jo tili?",
  "registration.title": "Rekisteröi tili",
  "registration.subtitle": "Rekisteröidy käyttäen {parts}",
  "settings.navigation-back-button": "Takaisin",
  "settings.subtitle": "Päivitä tilisi asetukset",
  "settings.title": "Tilin asetukset",
  "settings.password.title": "Vaihda salasana",
  "settings.password.description": "Muokkaa salasanaasi",
  "settings.profile.title": "Profiiliasetukset",
  "settings.profile.description": "Päivitä profiilitietojasi",
  "settings.webauthn.title": "Hallinnoi laiteavaimetukkeja",
  "settings.webauthn.description": "Hallinnoi laiteavaimiasetuksiasi",
  "settings.messages.toast-title.success": "Asetukset päivitetty",
  "settings.messages.toast-title.error": "Asetuksia ei voitu päivittää",
  "verification.title": "Vahvista tilisi",
  "verification.subtitle": "Anna tiliisi liittyvä sähköpostiosoite vahvistaaksesi sen",
  "two-step.password.title": "Salasana",
  "two-step.password.description": "Anna tiliisi liittyvä salasana",
  "two-step.code.title": "Sähköpostikoodi",
  "two-step.code.description": "Vahvistuskoodi lähetetään sähköpostiisi",
  "two-step.webauthn.title": "Turva-avain",
  "two-step.webauthn.description": "Käytä turva-avainta todentamiseen",
  "two-step.passkey.title": "Pääsyavain (suositeltu)",
  "two-step.passkey.description": "Käytä laitteesi sormenjälkeä tai kasvojentunnistusta",
  "two-step.passkey.description.error": "Tarvittavia kirjastoja ei voitu ladata pääsyavaimen käyttöön. Yritä myöhemmin uudelleen.",
  "two-step.totp.title": "Käytä todentajasovellustasi (TOTP)",
  "two-step.totp.description": "Käytä todentajasovelluksesi 6-numeroista kertakäyttökoodia",
  "two-step.lookup_secret.title": "Varmuuskoodi",
  "two-step.lookup_secret.description": "Käytä yksi kahdeksannumeroisista varmuuskoodeistasi todennukseen",
  "input.placeholder": "Anna {placeholder}",
  "card.header.parts.oidc": "sosiaalinen tarjoaja",
  "card.header.parts.password.registration": "{identifierLabel} ja salasana",
  "card.header.parts.password.login": "{identifierLabel} ja salasana",
  "card.header.parts.code": "kertakäyttökoodi",
  "card.header.parts.passkey": "pääsyavain",
  "card.header.parts.webauthn": "turva-avain",
  "card.header.parts.totp": "todentajasovelluksesi",
  "card.header.parts.lookup_secret": "varmuuskoodi",
  "card.header.parts.identifier-first": "{identifierLabel}",
  "misc.or": "tai",
  "forms.label.forgot-password": "Unohditko salasanan?",
  "forms.label.recover-account": "Palauta tili",
  "settings.totp.title": "Todentajasovellus",
  "settings.totp.description": "Lisää TOTP-todentajasovellus tilillesi parantaaksesi tilisi turvallisuutta. Suosittuja todentajasovelluksia ovat LastPass ja Google Authenticator",
  "settings.totp.info.not-linked": "Ota käyttöön skannaamalla QR-koodi todentajallasi ja syöttämällä koodi.",
  "settings.totp.info.linked": "Sinulla on tällä hetkellä todentajasovellus yhdistettynä.",
  "settings.lookup_secret.title": "Varmuuskoodit (kaksivaiheinen todennus)",
  "settings.lookup_secret.description": "Varmuuskoodit ovat turvallinen varmistus 2FA:lle, joiden avulla voit palauttaa pääsyn tiliisi, jos menetät 2FA-laitteesi.",
  "settings.oidc.title": "Yhdistetyt tilit",
  "settings.oidc.description": "Yhdistä sosiaalisen kirjautumisen tarjoaja tilillesi.",
  "settings.oidc.info": "Näiden tarjoajien yhdistettyjä tilejä voidaan käyttää tiliisi kirjautumiseen",
  "settings.webauthn.info": "Laiteavaimetukkeja käytetään kaksivaiheiseen todennukseen tai ensisijaisena todennuksena pääsyavainten kanssa",
  "settings.passkey.title": "Hallinnoi pääsyavaimia",
  "settings.passkey.description": "Hallinnoi pääsyavainasetuksiasi",
  "settings.passkey.info": "Hallinnoi pääsyavainasetuksiasi",
  "card.footer.select-another-method": "Valitse toinen menetelmä",
  "account-linking.title": "Linkitä tili",
  "property.password": "salasana",
  "property.email": "sähköposti",
  "property.phone": "puhelin",
  "property.username": "käyttäjätunnus",
  "property.identifier": "tunniste",
  "property.code": "koodi",
  "property.recovery_address": "palautusosoite",
  "consent.title": "Valtuuta {party}",
  "consent.subtitle": "Kolmannen osapuolen sovellus haluaa käyttää tiliisi {identifier} liittyviä tietoja.",
  "consent.scope.openid.title": "Identiteetti",
  "consent.scope.openid.description": "Sallii sovelluksen varmistaa identiteettisi. Tämä vaaditaan todennukseen ja luotettavaan kirjautumiskokemukseen.",
  "consent.scope.offline_access.title": "Offline-käyttö",
  "consent.scope.offline_access.description": "Sallii tämän sovelluksen pitää sinut kirjautuneena sisään, vaikka et aktiivisesti käytä sitä.",
  "consent.scope.profile.title": "Profiilitiedot",
  "consent.scope.profile.description": "Sallii pääsyn perustiedoillesi, mukaan lukien käyttäjätunnuksesi, etunimesi ja sukunimesi.",
  "consent.scope.email.title": "Sähköpostiosoite",
  "consent.scope.email.description": "Hae sähköpostiosoitteesi ja sen vahvistustila.",
  "consent.scope.address.title": "Postiosoite",
  "consent.scope.address.description": "Käytä postiosoitettasi.",
  "consent.scope.phone.title": "Puhelinnumero",
  "consent.scope.phone.description": "Hae puhelinnumerosi ja sen vahvistustila.",
  "error.title.what-happened": "Mitä tapahtui?",
  "error.title.what-can-i-do": "Mitä voin tehdä?",
  "error.instructions": "Yritä uudelleen muutaman minuutin kuluttua tai ota yhteyttä verkkosivuston ylläpitäjään.",
  "error.footer.text": "Kun raportoit tätä virhettä, sisällytä seuraavat tiedot:",
  "error.footer.copy": "Kopioi",
  "error.action.go-back": "Takaisin",
  "identities.messages.4000039": "Uuden salasanan on oltava eri kuin vanha salasana.",
  "identities.messages.4000040": "Anna kelvollinen sähköpostiosoite",
  "identities.messages.4000041": "Anna kelvollinen puhelinnumero",
  "captcha.error": "Suojaustarkistus epäonnistui. Yritä myöhemmin uudelleen. Jos ongelma jatkuu, ota yhteyttä tukeen.",
  "identities.messages.5000002": "Yhtään tunnistusmenetelmää ei ole käytettävissä. Ole hyvä ja ota yhteyttä järjestelmänvalvojaan.",
  "identities.messages.4010011": "Tämä käyttäjätili on poistettu käytöstä. Ota yhteyttä tukipalveluun saadaksesi apua.",
  "identities.messages.1070018": "Sähköpostiosoite tai puhelinnumero",
  "identities.messages.1080004": "Vahvistuskoodin sisältävä tekstiviesti on lähetetty antamaasi puhelinnumeroon. Jos et ole saanut tekstiviestiä, tarkista, että puhelinnumero on oikein kirjoitettu, ja varmista, että käytät rekisteröinnissä käyttämääsi numeroa.",
  "identities.messages.1080005": "Puhelinnumerosi vahvistaminen onnistui.",
  "identities.messages.5000003": "Organisaatiosi edellyttää SSO-todennusta, mutta mitään SSO-palveluntarjoajaa ei ole määritetty. Ota yhteyttä järjestelmänvalvojaan.",
  "identities.messages.1010024": "Kirjaudu sisään laitteistopohjaisella avaimella.",
  "identities.messages.1010025": "Koodi on lähetetty osoitteeseesi. Jos et saanut sitä, yritä uudelleen.",
  "identities.messages.4000042": "Sinulla ei ole käytössä yhtään DeviceAuthn-laitetta.",
  "identities.messages.4000043": "Antamasi verkkosivuston tunnistautumistiedot ovat virheelliset, yritä uudelleen.",
  "identities.messages.4000044": "Annettu DeviceAuthn-allekirjoitus on virheellinen.",
  "identities.messages.4050002": "Voit muuttaa vain yhden osoitteen kerrallaan. Päivitä jokainen osoite erikseen."
}
